<template>
  <b-modal id="voucher-info-modal" v-model="showModal" :title="$t('redeem.voucher.infotextHeading')">
    <p
      v-if="needsSpecialUKInfoText"
      v-html="
        $t('redeem.voucher.infotextuk30pounds', {
          value: voucherValueText,
          numberOfShops,
        })
      "
    />
    <p
      v-else
      v-html="
        $t('redeem.voucher.infotext', {
          value: voucherValueText,
          numberOfShops,
        })
      "
    />
    <template #modal-footer="{ hide }">
      <b-button variant="default" @click="hide()">
        {{ $t('wgs.std.buttonClose') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    /* If true, the voucher info modal is visible */
    show: {
      type: Boolean,
    },
  },

  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    ...mapGetters({
      numberOfShops: 'getNumberOfShops',
      voucherValue: 'getVoucherValue',
      voucherCurrency: 'getVoucherCurrency',
    }),

    voucherValueText() {
      return this.$n(this.voucherValue / 100, {
        key: 'currency',
        currency: this.voucherCurrency,
      });
    },

    needsSpecialUKInfoText() {
      return (this.voucherValue === 3000 && this.voucherCurrency === 'GBP');
    },
  },

  created() {
    setTimeout(() => {
      this.showModal = this.show;
    }, 1000);
  },
};
</script>
